import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseSearchInput } from "../utils/address";

interface SearchBarProps {
  className?: string;
  placeholder?: string;
}

export function SearchBar({
  className = "",
  placeholder = "Wallet address, explorer link or refcode",
}: SearchBarProps) {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = parseSearchInput(query);
    if (!parsed) return;

    if (parsed.kind === "wallet") {
      navigate(`/wallet/${parsed.address}`);
    } else {
      navigate(`/search?refcode=${encodeURIComponent(parsed.refcode)}`);
    }
    setQuery("");
  };

  return (
    <form onSubmit={handleSearch} className={`flex gap-2 ${className}`} role="search">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        aria-label="Search wallet address or refcode"
        className="input flex-1 min-w-0 py-1.5"
        autoComplete="off"
        spellCheck={false}
      />
      <button type="submit" className="btn btn-primary whitespace-nowrap py-1.5">
        Search
      </button>
    </form>
  );
}
